/** SEO для посадочных URL из топ-20 (semantic-core-top20-antologia-tech.md) */
import { NEWS_CATEGORIES, buildNewsHubPath, getNewsHubSeo } from '../lib/newsPublications';

const BASE = 'https://antologia.tech';

const newsHubPageSeo = Object.fromEntries(
  NEWS_CATEGORIES.map((category) => {
    const path = buildNewsHubPath(category.id);
    const seo = getNewsHubSeo(category.id);
    return [
      path,
      {
        title: seo.title,
        description: seo.description,
        canonical: seo.canonical,
        keywords: seo.keywords,
      },
    ];
  }),
);

export const PAGE_SEO = {
  '/': {
    title:
      'Лицензии и подписки на ПО для компаний — покупка, учёт, продление | Антология',
    description:
      'Поставщик лицензий и подписок на ПО: оплата в рублях для юрлиц, учёт в одном окне или делегирование менеджеру. Каталог решений и чат на закупку и продление.',
    canonical: `${BASE}/`,
  },
  '/solutions': {
    title: 'Каталог лицензий: российские и зарубежные IT и AI | Антология',
    description:
      'Каталог лицензий на российское и зарубежное ПО и AI: подбор, поставка на аккаунт клиента, on-premise и облако, внедрение и техподдержка.',
    canonical: `${BASE}/solutions`,
  },
  '/services': {
    title: 'Внедрение ИИ-решений: агенты, AI-based база данных (RAG), on-prem | Антология',
    description:
      'Интегратор B2B: внедрение ИИ-агентов, корпоративная AI-based база данных (RAG) и on-prem AI. Интеграция с CRM и базой знаний. Облако и on-premise, оплата в рублях, SLA.',
    canonical: `${BASE}/services`,
    keywords:
      'внедрение ИИ для бизнеса, корпоративная AI-based база данных RAG, ИИ-агенты, AI on-premise, интегратор B2B',
  },
  '/ai-agents-platform': {
    title: 'AI-based база данных и команда ИИ-агентов | Антология',
    description:
      'Внедрение корпоративной AI-based базы данных (RAG) и набора агентов: аутрич, стратегический, проектный, хелпдеск. On-premise и облако, SLA.',
    canonical: `${BASE}/ai-agents-platform`,
    keywords:
      'AI-based база данных, корпоративный RAG, ИИ-агенты для бизнеса, аутрич агент, хелпдеск ИИ, внедрение ИИ B2B',
  },
  '/enterprise-systems': {
    title: 'Внедрение корпоративных систем | Антология',
    description:
      'Поставка и внедрение корпоративного ПО: CRM/ERP 1С и Битрикс24, общее, ИБ, инфраструктура, САПР. Лицензии в рублях, настройка, интеграция и SLA для B2B.',
    canonical: `${BASE}/enterprise-systems`,
    keywords:
      'внедрение 1С, внедрение Битрикс24, CRM ERP кастомизация, внедрение корпоративных систем, поставка лицензий ПО, интегратор B2B',
  },
  '/about': {
    title: 'О компании — поставщик лицензий и подписок на ПО | Антология',
    description:
      'Антология — поставщик лицензий и подписок на ПО для компаний: покупка, учёт и продление в одном сервисе. Оплата в рублях; внедрение ИИ — отдельно на /services.',
    canonical: `${BASE}/about`,
  },
  '/faq': {
    title: 'Закупка лицензий на ПО и AI для компании | FAQ | Антология',
    description:
      'FAQ: закупка российских и зарубежных лицензий на ПО и AI, оплата в рублях, поставка, внедрение и SLA для юридических лиц.',
    canonical: `${BASE}/faq`,
  },
  '/privacy': {
    title: 'Политика обработки персональных данных | Антология',
    description:
      'Условия обработки персональных данных на antologia.tech: цели, сроки хранения, права субъекта, контакты оператора.',
    canonical: `${BASE}/privacy`,
  },
  '/cookies': {
    title: 'Cookies и аналитика | Антология',
    description:
      'Политика cookies antologia.tech: обязательные и аналитические файлы, Яндекс.Метрика, управление согласием.',
    canonical: `${BASE}/cookies`,
  },
  '/ready-for-ai': {
    title: 'Внедрение ИИ в бизнес - чек-лист готовности | Антология',
    description:
      'Оцените готовность компании к внедрению корпоративного ИИ. Чек-лист для COO и операционных директоров, консультация эксперта.',
    canonical: `${BASE}/ready-for-ai`,
  },
  '/ready-for-ai-sales': {
    title: 'AI для отдела продаж - чек-лист | Антология',
    description:
      'Чек-лист готовности отдела продаж к Generative AI: CRM, КП, контент. Подбор AI-решений для продаж.',
    canonical: `${BASE}/ready-for-ai-sales`,
  },
  '/discuss-ai': {
    title: 'Обсудить внедрение AI | Антология',
    description:
      'Оставьте заявку — эксперт Антологии свяжется с вами и поможет спланировать внедрение AI в ваш бизнес.',
    canonical: `${BASE}/discuss-ai`,
  },
  '/cbr': {
    title: 'ЦБР - центр быстрого реагирования | Поддержка AI-сервисов | Антология',
    description:
      'Поддержка AI-сервисов: Старт от 99 000 ₽ (тикеты, до 10 ч консультаций), ML-аналитика от 279 000 ₽, Операции от 490 000 ₽, выделенная команда ЦБР от 1 990 000 ₽/мес.',
    canonical: `${BASE}/cbr`,
  },
  '/gen-ai-creative': {
    title: 'Gen AI для команд: лицензии и оплата в ₽ | Антология',
    description:
      'Лицензии и подписки на ИИ-сервисы для команд: один договор, закрывающие документы. Оплата в рублях по безналичному расчёту. Пилот 4–8 недель, подбор тарифов под задачи.',
    keywords:
      'gen ai для команд, лицензии на ии сервисы, оплата ии в рублях, закупка нейросетей для юрлиц, подписки chatgpt для компании, лицензии claude для бизнеса, закрывающие документы на ии, пилот внедрения gen ai, безналичный расчёт ии сервисы, антология gen ai',
    canonical: `${BASE}/gen-ai-creative`,
    ogImage: `${BASE}/gen-ai-creative/assets/landing/hero-photo.webp`,
  },
  ...newsHubPageSeo,
};

export const VENDOR_PAGE_SEO = {
  'just-ai': {
    title: 'Just AI для бизнеса — лицензии по выгодной цене | Антология',
    description:
      'Лицензии Just AI для юридических лиц и ИП. Корпоративная связь, АТС, омниканальность, AI-речевая аналитика. Оплата в рублях по безналичному расчёту. Закрывающие документы, поставка лицензии на аккаунт клиента.',
    keywords:
      'лицензии just ai, лицензия just ai, цена just ai, just ai для юрлиц, оплата в рублях just ai, безналичный расчёт лицензия',
    canonical: `${BASE}/solutions/just-ai`,
  },
  uis: {
    title: 'Лицензии UIS по выгодной цене | Антология',
    description:
      'Лицензии UIS для юридических лиц и ИП. Корпоративный AI и телефония. Оплата в рублях по безналичному расчёту. Тариф с годовым планом. Закрывающие документы, поставка лицензии на аккаунт клиента.',
    keywords:
      'лицензии uis, лицензия uis, цена uis, jay copilot лицензия, uis для юрлиц, оплата в рублях uis',
    canonical: `${BASE}/solutions/uis`,
  },
};

/** URL для переобхода / IndexNow (топ-20 спринт) */
export const TOP20_LANDING_URLS = [
  '/',
  '/solutions',
  '/about',
  '/faq',
  '/ready-for-ai',
  '/ready-for-ai-sales',
  '/solutions/just-ai',
  '/solutions/uis',
];

export function getPageSeo(pathname) {
  return PAGE_SEO[pathname] || null;
}

export function getVendorPageSeo(slug) {
  return VENDOR_PAGE_SEO[slug] || null;
}
